module.exports = __webpack_public_path__ + "img/zh.dfc06be8.png";